var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.value ? _c('div', {
    staticClass: "notifications amelie--bg",
    class: {
      'menu-compact': !_vm.isWidest,
      'short': !_vm.hasMessages
    },
    on: {
      "mousedown": function ($event) {
        _vm.clickOutsidePanel = false;
      }
    }
  }, [_c('div', {
    staticClass: "header px-6 pt-6 pb-4"
  }, [_c('div', {
    staticClass: "d-flex mb-1"
  }, [_c('div', {
    staticClass: "flex-grow-1 taleggio harakiri--text"
  }, [_vm._v(" Оповещения ")]), _vm.hasUnreadByModule ? _c('div', {
    staticClass: "read-button-wrap",
    on: {
      "click": function () {
        return _vm.onReadConfirm(_vm.notifyMessagesByModule, true);
      }
    }
  }, [_vm._m(0), _c('r-button-action', {
    attrs: {
      "icon": "selection",
      "isArrow": false,
      "disabled": false,
      "color": "rocky",
      "size": "sulguni"
    }
  })], 1) : _c('div', {
    staticClass: "read-button-wrap biqe"
  }, [_c('r-button-action', {
    attrs: {
      "icon": "selection",
      "isArrow": false,
      "disabled": false,
      "color": "rocky",
      "size": "sulguni"
    }
  })], 1)]), _c('div', [_c('r-button-action', {
    attrs: {
      "title": _vm.selectedModuleName,
      "icon": null,
      "isArrow": true,
      "disabled": false,
      "color": "troy",
      "size": "briscola",
      "value": _vm.selectorModulesOpened
    },
    on: {
      "click": function ($event) {
        return _vm.onSelectorModule();
      }
    }
  }), _vm.selectorModulesOpened ? _c('div', {
    staticClass: "dropdown-custom mt-2 amelie--bg",
    on: {
      "mousedown": function ($event) {
        _vm.clickOutsideSelector = false;
      }
    }
  }, [_c('r-list-item', {
    attrs: {
      "title": "Все модули",
      "val": 'all',
      "value": _vm.sectedModule === null ? 'all' : null
    },
    on: {
      "input": function ($event) {
        return _vm.onSetModules(null);
      }
    }
  }), _vm._l(_vm.moduleList, function (item, index) {
    return _c('r-list-item', {
      key: ("module-item-" + index),
      attrs: {
        "title": item.senderName || 'Не указано',
        "val": item.senderCodes.join(','),
        "value": _vm.sectedModule ? _vm.sectedModule.senderCodes.join(',') : null
      },
      on: {
        "click": function ($event) {
          return _vm.onSetModules(item);
        }
      }
    });
  })], 2) : _vm._e()], 1)]), _c('div', {
    staticClass: "mb-2 px-6 d-flex"
  }, [_c('r-button-tag', {
    staticClass: "mr-2",
    attrs: {
      "title": "Все",
      "color": "rocky",
      "value": !_vm.unreadOnly
    },
    on: {
      "input": function () {
        return _vm.unreadOnly = false;
      }
    }
  }), _c('r-button-tag', {
    attrs: {
      "title": "Непрочитанные",
      "color": "rocky",
      "value": !!_vm.unreadOnly,
      "disabled": !_vm.hasReadedMessages
    },
    on: {
      "input": function () {
        return _vm.unreadOnly = true;
      }
    }
  })], 1), _c('div', {
    staticClass: "notification-list px-2 pb-2"
  }, [!_vm.hasMessages ? [_c('div', {
    staticClass: "mt-6 mb-4 empty-list feta metropolis--text"
  }, [_vm._v(" " + _vm._s(_vm.unreadOnly ? 'Непрочитанных' : 'Новых') + " оповещений пока нет ")])] : _vm._e(), _vm.hasMessages && _vm.notifyMessagesByModule.length ? _vm._l(_vm.notifyMessagesByModule, function (message, index) {
    return _c('div', {
      key: ("message-" + index),
      staticClass: "item can-read d-flex pt-4 pb-4 px-4",
      class: {
        'received': message.isRead
      },
      on: {
        "click": function ($event) {
          return _vm.onViewNotification(message);
        }
      }
    }, [_vm.isShowIcon(message) ? _c('div', {
      staticClass: "mr-3"
    }, [message.critical === 'HIGH' ? _c('r-icon', {
      attrs: {
        "icon": "warning",
        "size": "32",
        "fill": "lebowski"
      }
    }) : _vm._e(), message.critical === 'CRITICAL' ? _c('r-icon', {
      attrs: {
        "icon": "emergency",
        "size": "32",
        "fill": "fargo"
      }
    }) : _vm._e()], 1) : _vm._e(), _c('div', {
      staticClass: "flex-grow-1"
    }, [_c('div', {
      staticClass: "mozzarella troy--text mb-1"
    }, [_vm._v(" " + _vm._s(_vm.formatDate(message.messageDate, message.ignoreTimezone)) + " " + _vm._s(_vm.formatModuleName(message) ? ("• " + (_vm.formatModuleName(message))) : '') + " ")]), _c('div', {
      staticClass: "sulguni harakiri--text break-all"
    }, [_vm._v(" " + _vm._s(_vm.formatMessageText(message)) + " ")])]), !message.isRead ? _c('div', {
      staticClass: "read-button-wrap",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return function () {
            return _vm.onReadConfirm([message], false);
          }.apply(null, arguments);
        }
      }
    }, [_vm._m(1, true), _c('r-icon', {
      staticClass: "ml-3",
      attrs: {
        "icon": "selected",
        "size": "16",
        "fill": "rocky"
      }
    })], 1) : _vm._e()]);
  }) : _vm._e(), _vm.hasMessages && !_vm.notifyMessagesByModule.length && _vm.sectedModule !== null ? [_c('div', {
    staticClass: "mt-6 mb-4 empty-list feta metropolis--text"
  }, [_vm._v(" Оповещений в выбраном модуле нет ")])] : _vm._e()], 2)]) : _vm._e();
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "RTooltip__content top-center end arrow view",
    staticStyle: {
      "position": "fixed",
      "margin": "0px",
      "max-width": "224px",
      "top": "74px",
      "right": "60px"
    }
  }, [_vm._v(" Пометить все как прочитанные "), _c('div', {
    staticClass: "RTooltip__arrow top-center end"
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "RTooltip__content top-center end arrow view",
    staticStyle: {
      "position": "fixed",
      "margin": "-34px 0px 0px -154px",
      "max-width": "198px"
    }
  }, [_vm._v(" Пометить как прочитанное "), _c('div', {
    staticClass: "RTooltip__arrow top-center end"
  })]);
}]

export { render, staticRenderFns }